import { Component, OnInit } from '@angular/core'
import { Renderer2 } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import * as AOS from 'aos'

import { environment } from './environments/environment'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(private renderer: Renderer2) {}
  ngOnInit() {
    const gtmScript = this.renderer.createElement('script')
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id=${environment.GTM_ID}'+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${environment.GTM_ID}');`

    this.renderer.appendChild(document.head, gtmScript)
  }

  ngAfterViewInit() {
    AOS.init()
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts